import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { SnackbarProvider as NSnackbarProvider } from 'notistack';

function SnackbarProvider(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      rest = _objectWithoutProperties(_ref, ["children", "classes"]);

  return React.createElement(NSnackbarProvider, _extends({}, rest, {
    classes: {
      variantSuccess: classes.success,
      variantError: classes.error,
      variantWarning: classes.warning,
      variantInfo: classes.info
    }
  }), children);
}

SnackbarProvider.propTypes = {
  children: PropTypes.node,

  /**
   * @ignore
   */
  classes: PropTypes.shape({
    error: PropTypes.string,
    info: PropTypes.string,
    success: PropTypes.string,
    warning: PropTypes.string
  }).isRequired,

  /**
   * Maximalni pocet zobrazovanych zprav.
   */
  maxSnack: PropTypes.number,
  preventDuplicate: PropTypes.bool
};
SnackbarProvider.defaultProps = {
  children: null,
  maxSnack: 5,
  preventDuplicate: true
};
export default withStyles(function (theme) {
  return {
    success: {
      color: theme.palette.success.contrastText,
      backgroundColor: theme.palette.success.main
    },
    error: {
      color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.dark
    },
    info: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.dark
    },
    warning: {
      color: theme.palette.warning.contrastText,
      backgroundColor: theme.palette.warning.main
    }
  };
})(SnackbarProvider);